import mojs from '@mojs/core';

const COLORS = {
	RED: '#FD5061',
	YELLOW: '#FFCEA5',
	BLACK: '#29363B',
	WHITE: 'white',
	VINOUS: '#A50710'
};

const burst1 = new mojs.Burst({
	left: 0, top: 0,
	count: 8,
	radius: { 50: 150 },
	children: {
		shape: 'line',
		stroke: [ '#E01B21', '#534338', '#78C6C3', '#FDF5CF', '#FEFCF4' ],
		scale: 1,
		scaleX: { 1 : 0 },
		// pathScale: 'rand(.5, 1.25)',
		degreeShift: 'rand(-90, 90)',
		radius: 'rand(20, 40)',
		// duration: 200,
		delay: 'rand(0, 150)',
		isForce3d: true
	}
});

const largeBurst = new mojs.Burst({
	left: 0, top: 0,
	count: 4,
	// radius: 0,
	angle: 45,
	radius: { 0: 450 },
	children: {
		shape: 'line',
		stroke: '#534338',
		scale: 1,
		scaleX: { 1 : 0 },
		radius: 100,
		duration: 450,
		isForce3d: true,
		easing: 'cubic.inout'
	}
});

const CIRCLE_OPTS = {
	left: 0, top: 0,
	scale: { 0: 1 },
};

const largeCircle = new mojs.Shape({
	...CIRCLE_OPTS,
	fill: 'none',
	stroke: '#FEFCF4',
	strokeWidth: 4,
	opacity: { .25 : 0 },
	radius: 250,
	duration: 600,
});

const smallCircle = new mojs.Shape({
	...CIRCLE_OPTS,
	fill: '#FEFCF4',
	opacity: { .5 : 0 },
	radius: 30,
});

export function launchFirework( positionX, positionY, delay ) {
	if( delay !== undefined && delay > 0 ) {
		setTimeout( function() {
			burst1.tune({ x: positionX, y: positionY, isShowEnd: false }).generate().replay();
			largeBurst.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
			largeCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
			smallCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
		}, delay );
	} else {
		burst1.tune({ x: positionX, y: positionY, isShowEnd: false }).generate().replay();
		largeBurst.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
		largeCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
		smallCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
	}
}

